import {
  AUTH_ACCESS_TOKEN,
  AUTH_EMITTED_IN,
  AUTH_EXPIRES_IN,
  AUTH_PERSONA_ID,
  AUTH_REFRESH_TOKEN,
  AUTH_ROLE_ID
} from '../../models';
import {
  authAccessTokenFailure,
  authAccessTokenRequest,
  authAccessTokenSuccess,
  authDPIRedirect,
  authLoginFailure,
  authLoginRequest,
  authLoginSuccess,
  authLogout,
  authLogoutFailure,
  authLogoutSuccess,
  authPutRoleSuccess
} from './auth.actions';
import {Action, createReducer, on} from '@ngrx/store';

import {LocalStorageService} from '../../services';
import {AuthState} from "../states/auth-state";

const localStorageService = new LocalStorageService();

export const initialState: AuthState = {
  personaId: localStorageService.getItem(AUTH_PERSONA_ID),
  access_token: localStorageService.getItem(AUTH_ACCESS_TOKEN),
  refresh_token: localStorageService.getItem(AUTH_REFRESH_TOKEN),
  expires_in: Number(localStorageService.getItem(AUTH_EXPIRES_IN)),
  emitted: Number(localStorageService.getItem(AUTH_EMITTED_IN)),
  rolId: localStorageService.getItem(AUTH_ROLE_ID),
  isLoading: false,
  error: null
};

const reducer = createReducer(
  initialState,
  on(authDPIRedirect, state => ({
    ...state,
    personaId: null,
    access_token: null,
    refresh_token: null,
    expires_in: null,
    rolId: null,
    isLoading: true,
    error: null
  })),
  on(authLoginRequest, state => ({
    ...state,
    personaId: null,
    isLoading: true,
    error: null
  })),
  on(authAccessTokenRequest, state => ({
    ...state,
    personaId: null,
    isLoading: true,
    error: null
  })),
  on(authAccessTokenSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    personaId: null,
    access_token: payload.tokens.access_token,
    refresh_token: payload.tokens.refresh_token,
    expires_in: payload.tokens.expires_in
  })),
  on(authAccessTokenFailure, state => ({
    ...state,
    isLoading: false,
    personaId: null
  })),
  on(authLoginSuccess, (state, payload) => ({
    ...state,
    personaId: payload.personaId,
    isLoading: false,
    error: null
  })),
  on(authLoginFailure, (state, payload) => ({
    ...state,
    personaId: null,
    isLoading: false,
    error: payload.error
  })),
  on(authPutRoleSuccess, (state, payload) => ({
    ...state,
    rolId: payload.role.rolId,
    isLoading: true,
    error: null
  })),
  on(authLogout, state => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(authLogoutSuccess, (state, payload) => ({
    ...state,
    personaId: null,
    isLoading: payload.isLoading,
    access_token: null,
    refresh_token: null,
    rolId: null,
    expires_in: null
  })),
  on(authLogoutFailure, state => ({
    ...state,
    isLoading: false,
    error: null
  }))
);

export function authReducer(
  state: AuthState | undefined,
  action: Action
): AuthState {
  return reducer(state, action);
}
